import noop from 'lib/function/noop'
import { createReducer } from 'lib/redux/reducerUtils'
import { createContext } from 'react'
import { ValueOf } from 'type-fest'

export interface ContentfulModalState {
  currentStep: string | null
}

export enum ContentfulModalDispatchActions {
  GO_TO = 'GO_TO',
}

const initialContentfulModalState: ContentfulModalState = { currentStep: null }

export type ContentfulModalDispatchAction = ValueOf<Utils.FullActionMap<{
  [ContentfulModalDispatchActions.GO_TO]: { step?: string }
}>>

export const ContentfulModalStateReducer = createReducer<ContentfulModalState, ContentfulModalDispatchAction>(
  initialContentfulModalState,
  {
    [ContentfulModalDispatchActions.GO_TO]: (_state, action) => ({
      currentStep: action.step,
    }),
  },
)

export const ContentfulModalStateContext = createContext<ContentfulModalState>(initialContentfulModalState)
export const ContentfulModalDispatchContext = createContext<React.Dispatch<ContentfulModalDispatchAction>>(noop)
